<template>
  <div id="Content" class="container-fluid">

    <Storage/>

    <div style="float: right;height: 40px;position: absolute;z-index: 2;right: 60px;">
      <button
        class="btn btn-outline-secondary"
        style="float: right;margin-right: 5px;"
        v-if="userLog"
        @click="logout"
      >{{ $t("message.logout") }}</button>
      <router-link :to="{name: 'ProfilePage'}">
        <button
          class="btn btn-outline-secondary"
          style="float: right;margin-right: 5px;"
          v-if="userLog"
        >{{ $t("message.profil") }}</button>
      </router-link>
      <router-link :to="{name: 'PriceListPage'}">
        <button
          class="btn btn-outline-secondary"
          style="float: right;margin-right: 5px;"
        >{{ $t("message.anuluj") }}</button>
      </router-link>
    </div>

    <Header/>
    <Main/>

    <back-to-top bottom="20px" right="40px">
      <button type="button" class="btn btn-default btn-to-top">
        <i class="fa fa-level-up"></i>
      </button>
    </back-to-top>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Storage from "./Storage/Storage.vue";
import Header from "./Header.vue";
import Main from "./Main.vue";
import Rises from "./Rises/Rises.vue";
import Reductions from "./Reductions/Reductions.vue";
import News from "./News/News.vue";
import Phone from "./Phone/Phone.vue";

export default {
  name: "Content",
  data() {
    return {
      userLog: false
    };
  },
  components: {
    Storage,
    Header,
    Main,
    Rises,
    Reductions,
    News,
    Phone
  },
  computed: {
     ...mapGetters('version', ['version']),
  },
  methods: {
    logout() {
      sessionStorage.clear();
      this.userLog = false;
      this.$router.push({ name: "LoginPage" });
    }
  },
  created() {
    console.log('-- content created --')

    document.title = this.$t("message.title");
    let userSession = sessionStorage.getItem("userLog");

    if (userSession == null && process.env.VUE_APP_Log_In == true) {
    //   this.$router.push({ name: "LoginPage" });
      this.userLog = false;
    } else {
      this.userLog = true;
      if (this.$route.params && this.$route.params.pricelist) {
        sessionStorage.setItem("listType", this.$route.params.pricelist);
        this.$store.commit('pricelist/SET_LISTTYPE', this.$route.params.pricelist)
      } else {

        let sessionListType = sessionStorage.getItem("listType");

        if (sessionListType == 'pulsar' || sessionListType == 'mw') {
          if (sessionListType == 'pulsar' && this.version.pulsarSerwis)
          {
            this.$router.push({ name: "PriceListPage" })
          }
          else if (sessionListType == 'mw' && this.version.mwSerwis)
          {
            this.$router.push({ name: "PriceListPage" })

          }
          else if (Object.keys(this.version).length == 0)
          {
            this.$router.push({ name: "PriceListPage" })

          }

          else {
            console.log('else')
            this.$store.commit('pricelist/SET_LISTTYPE', sessionListType)
          }

        } else {
          if (process.env.VUE_APP_Log_In == true) {
            this.$router.push({ name: "LoginPage" })
            this.userLog = false;
          } else {
            this.$router.push({ name: "PriceListPage" })
            this.userLog = true;
          }
        }
      }
    }
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Roboto");
body {
  /* background: #f8f8f8; */
  width: 100vw;
}
html {
  overflow-y: scroll;
}
#app {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 0px;
  background-color: #f8f8f8;
  font-size: 20px;
}
#app .logo {
  width: 240px;
  padding: 15px 0;
}
#Content {
  background: #fff !important;
}
.container-fluid {
  max-width: 1520px;
  padding: 10px 40px;
  /* background: #fff; */
  position: relative;
}
.versionOuter {
  position: relative;
}
.overlay {
  background: rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 999;
}
.btn-to-top{
  background: #7d7d7d !important;
  color:white  !important;
}
.btn-to-top i{
  font-size: 20px;
}
.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: #ddd;
  color: #2c3e50;
  border-radius: 7.5px;
  padding: 10px 15px 15px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: #ddd;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, 0.1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}

.btn-primary,
.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show > .btn-primary.dropdown-toggle {
  background: #23497f;
  color: #fff;
  border-color: #23497f;
}

.btn-default,
.btn-default:not(:disabled):not(.disabled).active,
.btn-default:not(:disabled):not(.disabled):active,
.show > .btn-default.dropdown-toggle {
  background: #fff;
  color: #23497f;
  border-color: #fff;
  border: 1px solid #23497f;
  border-left: 1px solid #23497f;
  border-right: 1px solid #23497f;
  border: 0;
}
.btn-link,
.btn-link:not(:disabled):not(.disabled).active,
.btn-link:not(:disabled):not(.disabled):active,
.show > .btn-link.dropdown-toggle {
  color: #23497f;
}
h2 {
  position: relative;
}
a[disabled="disabled"] {
  pointer-events: none;
}

.form-check-label {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
}

.btnRight {
  font-size: 13px;
  padding: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Content.vue